import { Box } from "@mui/joy";

export function IconBadge({ icon: Icon }) {
    return (
        <Box
            sx={(theme) => ({
                width: 52,
                height: 52,
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(89, 160, 244, 0.3)',
                color: 'var(--joy-palette-primary-500)',
                mb: 2,
                flexShrink: 0,
                [theme.getColorSchemeSelector('dark')]: { color: '#fff' },
            })}
        >
            <Icon size={28} weight="fill" />
        </Box>
    );
}
